export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAADklEQVQYV2NgGAWDEwAAAZoAAWtx0p4AAAAASUVORK5CYII="